import {
  REVIEW_SETUP,
  REVIEW_SETUP_EXCLUSION_REASONS,
  REVIEW_SETUP_HIGHLIGHTS,
  tokenizeRoute,
} from 'query/routes';
import { getReviewId } from 'query/review';

export type ReviewSetupLinks = {
  reviewSetupLink: string | URL;
  eligibilityCriteriaLink: string | URL;
  highlightsLink: string | URL;
  exclusionReasonsLink: string | URL;
};

export const useReviewSetupLinks = (): ReviewSetupLinks => {
  const reviewId = getReviewId();
  const reviewSetupLink = tokenizeRoute(REVIEW_SETUP, { review_id: reviewId });

  return {
    reviewSetupLink,
    eligibilityCriteriaLink: reviewSetupLink,
    highlightsLink: tokenizeRoute(REVIEW_SETUP_HIGHLIGHTS, {
      review_id: reviewId,
    }),
    exclusionReasonsLink: tokenizeRoute(REVIEW_SETUP_EXCLUSION_REASONS, {
      review_id: reviewId,
    }),
  };
};
